/**
 * @description 易错/收藏题目数
 */

import Api from '../../../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IInput {
    practice_type: number; // 1 易错题，2 已收藏
}

export interface IOutput {
    cnt: number;
}

export const getQuestionCount = (data: IInput): Promise<IOutput> => {
    return fetchData(Api.QUESTION_COLLECTION_GET_QUESTION_COUNT, data).then((res: IResponse<IOutput>) => {
        return res.data;
    });
};
